export const baseUrl = `https://127.0.0.1:41951/DYMO/DLS/Printing`;

export type Printer = {
  name: string;
  modelName: string;
  isLocal: boolean;
  isConnected: boolean;
  isTwinTurbo: boolean;
};
